import { ErrorBoundaryContainer } from '@save/styleguide';
import React from 'react';

export default function ErrorBoundary(error, info, props) {
  return <ErrorBoundaryContainer applicationName={props.name} error={error}></ErrorBoundaryContainer>;
}
